import { LoginBody, LoginResponse } from "../../sdk/types"

import { Action } from "./reducer"
import { Dispatch } from "react"
import client from "../../utils/client"
import { deleteCookie } from "../../utils/cookie"
import queryClient from "../../utils/query-client"

const login = async (
    dispatch: Dispatch<Action>,
    body: LoginBody,
    options: { onSuccess: (response: LoginResponse) => void; onError: (error: unknown) => void }
) => {
    try {
        dispatch({ type: "REQUEST_LOGIN" })
        const response = await client.login(body)
        dispatch({ type: "LOGIN_SUCCESS" })
        options && options.onSuccess(response)
        return
    } catch (error) {
        options && options.onError(error)
        dispatch({ type: "ERROR", error: error })
    }
}

const logout = (dispatch: Dispatch<Action>) => {
    try {
        dispatch({ type: "LOGOUT" })
        client.logout()
        deleteCookie("__is_partner__")
        queryClient.clear()
        window.posthog?.reset()
        return
    } catch (error) {
        dispatch({ type: "ERROR", error: error })
    }
}

export { login, logout }
